export default "__VITE_ASSET__oI6jhP$6__"